import React, { useState, useEffect } from 'react'
import { Table, TableBody, TableCell, TableContainer, Pagination, TableHead, TableRow, Dialog } from '@mui/material'
import { useSelector } from 'react-redux';
import { useAuthContext } from '../../hooks/agencyAuthHook'
import {Link} from 'react-router-dom'
import toast from 'react-hot-toast'
import ConfigurationsHook from '../../hooks/ConfigurationsHook';
import PackagesHook from '../../hooks/PackagesHook';
import BookingHook from '../../hooks/BookingHook';
import InstructionsHook from '../../hooks/InstructionsHook';
import { DatePicker,ConfigProvider  } from 'antd';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import VoucherColorsHook from '../../hooks/VoucherColorsHook';

import hajj_package from '../../assets//images/hajj_package.png'
import umrah_package from '../../assets//images/umrah_package.png'
import Radio from '@mui/material/Radio';
import logo from '../../assets/images/gohijaz.png'
export default function Bookings() {

  const apiUrl = process.env.REACT_APP_API_URL;
  const { getConfigurations } = ConfigurationsHook();
  const { getPackages } = PackagesHook();
  const { getBookings } = BookingHook();
    const { getInstructions } = InstructionsHook();
    const { getVoucherColors } = VoucherColorsHook();
      dayjs.extend(customParseFormat);

  useEffect(() => {
    document.title = "Bookings"
    getBookings()
    getPackages()
    getConfigurations()
    getInstructions()
    getVoucherColors()
  }, [])


  const profile = useSelector((state) => state.profile.profile);
  const instructions = useSelector((state) => state.instructions.instructions);
  const vouchercolors = useSelector((state) => state.vouchercolors.vouchercolors);

  const { agency } = useAuthContext()
  // Booking Edition
  const [editedBookingId, setEditedBookingId] = useState('')
  const [newBooking, setNewBooking] = useState(false)
  const [package_type, setpackage_type] = useState('umrah package')
  const [totalPrice, settotalPrice] = useState(0)

  const [openNew, setOpenNew] = React.useState(false);
  const handleClickOpenNew = () => {
    setOpenNew(true);
  };

  const handleCloseNew = () => {
    setOpenNew(false);
    setpackage_type('umrah package')
  }
  // States 
  const [packageId, setpackageId] = useState('')
  const [adults, setadults] = useState(0)
  const [children, setchildren] = useState(0)
  const [infants, setinfants] = useState(0)

  const [shirka, setshirka] = useState('')
  const [shirkaId, setshirkaId] = useState('')

  const [group_code, setgroup_code] = useState('')
  const [remarks, setremarks] = useState('')

  const [totalMembers, settotalMembers] = useState(1)
  const [room_type, setroom_type] = useState('')
  const [members, setmembers] = useState([{
    name: '', age_group: '', dob: '', ppNo: '', pp_expiry_date: '', pp_image: '', visa_number: '', visa_issue_date: '', phone: '', address: '', gender: '', pnr_number: '', mofa_date: ''
  }])

  // Function to add a new member
const addNewMember = () => {
  // Create a new member object with default values
  const newMember = {
    name: '',
    age_group: '',
    dob: '',
    ppNo: '',
    pp_expiry_date: '',
    pp_image: '',
    visa_number: '',
    visa_issue_date: '',
    phone: '',
    address: '',
    gender: '',
    pnr_number: '',
    mofa_date: ''
  };

  // Append the new member to the existing array
  setmembers((prevMembers) => [...prevMembers, newMember])
  settotalMembers(totalMembers+1)
}

console.log('members',members)
// Function to delete a member
const deleteMember = (index) => {
  setmembers((prevMembers) => {
    // Filter out the member at the given index
    const updatedMembers = prevMembers.filter((_, i) => i !== index);
    return updatedMembers;
  });

  // Decrement the total members count
  settotalMembers((prevTotal) => Math.max(prevTotal - 1, 0));
};


  const validateMembers = (members) => {
    return members.some((member) => {
      return (
        member.name?.trim() &&
        member.age_group?.trim() &&
        member.dob?.trim() &&

        member.phone?.trim() &&
        member.age_group?.trim() &&
        member.gender?.trim() &&
        member.mofa_date?.trim()
      );
    });
  };

  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [memberIndex, setmemberIndex] = useState();

  const [editedMember, setEditedMember] = useState({
    name: '',
    age_group: '',
    dob: '',
    ppNo: '',
    pp_expiry_date: '',
    pp_image: '',
    visa_number: '',
    visa_issue_date: '',
    pnr_number: '',
    mofa_date: '',
    phone: '',
    address: '',
    gender: ''
  });

  // Open dialog with selected member details
  const handleAddDetails = (index) => {

    setEditedMember({ ...members[index] });
    setIsDialogOpen(true);
    setmemberIndex(index)
  };

  const resetMemberdetails = () => {
    setEditedMember({
      name: '',
      age_group: '',
      dob: '',
      ppNo: '',
      pp_expiry_date: '',
      pp_image: '',
      visa_number: '',
      visa_issue_date: '',
      pnr_number: '',
      mofa_date: '',
      phone: '',
      address: '',
      gender: ''
    });

    // Optionally, reset the member details in the members array
    const updatedMembers = [...members];
    updatedMembers[memberIndex] = {
      name: '',
      age_group: '',
      dob: '',
      ppNo: '',
      pp_expiry_date: '',
      pp_image: '',
      visa_number: '',
      visa_issue_date: '',
      pnr_number: '',
      mofa_date: '',
      phone: '',
      address: '',
      gender: ''
    };
    setmembers(updatedMembers);
  };



// Helper function to update age groups number dynamically
const updateCounts = (members) => {
  let adultsCount = 0;
  let childrenCount = 0;
  let infantsCount = 0;

  // Loop through each member and count adults, children, and infants
  members.forEach((member) => {
    if (member.age_group === "Adult") adultsCount++;
    if (member.age_group === "Child") childrenCount++;
    if (member.age_group === "Infant") infantsCount++;
  });

  // Ensure the total does not exceed totalMembers
  if (adultsCount + childrenCount + infantsCount <= totalMembers) {
    setadults(adultsCount);
    setchildren(childrenCount);
    setinfants(infantsCount);
  }
};


// Handle form field changes inside dialog
const handleFieldChange = (key, value) => {
  setEditedMember((prev) => ({ ...prev, [key]: value }));

  // Update the specific member in the members array
  const updatedMembers = [...members];  // Don't mutate directly, create a new array
  updatedMembers[memberIndex] = { ...updatedMembers[memberIndex], [key]: value };

  // If the field is "dob", calculate age and determine age group
  if (key === "dob") {
    const dob = new Date(value);
    const today = new Date();
    const age = today.getFullYear() - dob.getFullYear() - (today < new Date(today.getFullYear(), dob.getMonth(), dob.getDate()) ? 1 : 0);

    let ageGroup = "Adult"; // Default to Adult
    if (age < 2) {
      ageGroup = "Infant";
    } else if (age < 12) {
      ageGroup = "Child";
    }
    // Update the age group in updatedMembers immediately
    updatedMembers[memberIndex].age_group = ageGroup;
    setEditedMember((prev) => ({ ...prev, age_group: ageGroup }));  // Update the age group in editedMember as well

    setmembers(updatedMembers);  // Directly update the members array here

  } else {
    setmembers(updatedMembers);
  }
}

// Track the count of adults, children, and infants dynamically
useEffect(() => {
  updateCounts(members);
}, [members]);



  // Save changes and close dialog
  const handleSaveChanges = () => {
    if (editedMember?.name?.trim() === '' || editedMember?.dob?.trim() === '' || editedMember?.age_group?.trim() === '' || editedMember?.ppNo?.trim() === '' || editedMember?.gender?.trim() === '') {
      toast.error('Please fill the required details to save the changes')
    }
    else {
      const updatedMembers = [...members];
      updatedMembers[memberIndex] = editedMember; // Save changes to the member at memberIndex
      setmembers(updatedMembers);
      setIsDialogOpen(false);
      setEditedMember(null);
    }

  }
  
  const handleTotalMembersChange = (e) => {
    const value = parseInt(e.target.value, 10);
  
    // Allow user to input `0` or clear the field, but treat it as `1` internally
    const total = Math.max(1, value || 0); // Default to 1 if value is invalid or less than 1
    settotalMembers(value || ''); // Reflect user input in the UI (even if it's 0 or empty)
  
    const currentMembers = [...members];

    if (total > currentMembers.length) {
      // If increasing totalMembers, append new empty member objects
      for (let i = currentMembers.length; i < total; i++) {
        currentMembers.push({
          name: '',
          age_group: '',
          dob: '',
          ppNo: '',
          pp_expiry_date: '',
          pp_image: '',
          visa_number: '',
          visa_issue_date: '',
          pnr_number: '',
          mofa_date: '',
          phone: '',
          address: '',
          gender: ''
        });
      }
    } else if (total < currentMembers.length) {
      // If decreasing totalMembers, truncate the array
      currentMembers.splice(total);
    }
  
    setmembers(currentMembers);
  }

  // Handle adults, children, and infants change
  const handleAdultsChange = (e) => {
    const value = Math.max(0, parseInt(e.target.value, 10) || 0);
    if (value + Number(children) + Number(infants) <= Number(totalMembers)) {
      setadults(value);
    }
  }

  const handleChildrenChange = (e) => {
    const value = Math.max(0, parseInt(e.target.value, 10) || 0);
    if (Number(adults) + value + Number(infants) <= Number(totalMembers)) {
      setchildren(value);
    }
  }
  const handleInfantsChange = (e) => {
    const value = Math.max(0, parseInt(e.target.value, 10) || 0);
    if (Number(adults) + Number(children) + value <= Number(totalMembers)) {
      setinfants(value);
    }
  }

  // Handle passport picture upload
  const handlePPImage = (e, index) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 5 * 1024 * 1024) {
        toast.error("File size exceeds the 5MB limit. Please select a smaller file.");
        return;
      }
      transformPPFile(file, index);
    }
  };

  // Transform file to Base64
  const transformPPFile = (file, index) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      const updatedMembers = [...members];
      updatedMembers[index].pp_image = reader.result; // Update the member's pp_image
      setmembers(updatedMembers);
      setEditedMember(prevState => ({
        ...prevState,
        pp_image: reader.result,
      }));
    };
  }

  const handleEditBooking = (data) => {
    setEditedBookingId(data._id)
    setNewBooking(true)
    setpackageId(data.packageId)
    setshirka(data.shirka)
    setgroup_code(data.group_code)
    setremarks(data.remarks)
setshirkaId(data.shirkaId)
    setpackage_type(data.package_header)
    settotalPrice(data.totalPrice)
    setadults(data.adults)
    setchildren(data.children)
    setinfants(data.infants)
    settotalMembers(data.totalMembers)
    setmembers(data.members)
    setroom_type(data.room_type)

  }

  // Resetting form
  const resetForm = () => {
    setEditedBookingId('')
    setNewBooking(false)
    setpackage_type('umrah package')
    settotalPrice(0)
    setpackageId('')
    setshirkaId('')

    setgroup_code('')
    setremarks('')


    setadults(0)
    setchildren(0)
    setinfants(0)
    settotalMembers(1)
    setmembers([{
      name: '', age_group: '', dob: '', nationality: '', ppNo: '', pp_expiry_date: '', pp_image: '', visa_number: '', visa_issue_date: '', phone: '', address: '', gender: ''
    }])
  }


  // API Call to add a new Booking
  const [loading1, setLoading1] = useState(false)
  const addNewBooking = async () => {
    if(totalMembers===1){
      setadults(1)
    }
    if (!validateMembers(members) || !packageId || Number(totalMembers) < 1) {
      toast.error('Please provide all details about booking!')
    }
  
    else if ((adults + children + infants) < totalMembers) {
      toast.error('Please complete the members selection')
    }
    else {
      setLoading1(true)
      try {
        const response = await fetch(`${apiUrl}/api/agencies/bookings/add`, {
          method: "POST",
          headers: {
            'Authorization': `Bearer ${agency.token}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            data: {
              packageId,
              shirkaId,
              remarks,
              totalPrice,
              totalMembers,
              adults,
              children,
              infants,
              group_code,
              room_type,
              members
            }
          })
        })
        const json = await response.json()
        if (response.ok) {
          toast.success(json.message)
          setLoading1(null)
          resetForm()
          getBookings()

        }
        if (!response.ok) {
          toast.error(json.message)
          setLoading1(null)
        }
      } catch (error) {
        setLoading1(null)
      }
    }

  }

  const updateBooking = async () => {
    if(totalMembers===1){
      setadults(1)
    }
    if (!validateMembers(members) || !packageId || Number(totalMembers) < 1 ) {
      toast.error('Please provide all details about booking!')
    }
    else if ((Number(adults) + Number(children) + Number(infants)) < Number(totalMembers)) {
      toast.error('Please complete the members selection')
    }
    else {
      setLoading1(true)
      try {
        const response = await fetch(`${apiUrl}/api/agencies/bookings/update`, {
          method: "PUT",
          headers: {
            'Authorization': `Bearer ${agency.token}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            data: {
              _id: editedBookingId,
              
              packageId,
              totalPrice,
              remarks,
              shirkaId,
              totalMembers,
              adults,
              children,
              infants,
              room_type,
              group_code,
              members
            }
          })
        })

        const json = await response.json()
        if (response.ok) {
          toast.success(json.message)
          setLoading1(null)
          resetForm()
          getBookings()

        }
        if (!response.ok) {
          toast.error(json.message)
          setLoading1(null)
        }
      } catch (error) {
        setLoading1(null)
      }
    }

  }

  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const rowsPerPage = 10;
  // Handle search input change
  const handleSearchChange = (event) => {
    setSearch(event.target.value);
    setPage(1);
  };

  // Handle pagination change
  const handlePageChange = (event, value) => {
    setPage(value);
  };


  const packages = useSelector((state) => state.packages.packages);
  useEffect(() => {
    if (packageId && totalMembers) {
      const selectedPackage = packages.find((item) => item._id === packageId);
      if (selectedPackage) {
        const availableSlots = selectedPackage.total_slots - selectedPackage.sold;
        if (totalMembers > availableSlots) {
          toast.error('Total Members should not exceed available slots')
          settotalMembers(availableSlots)
        }
      }
    }
  }, [packageId, totalMembers, packages])


  const configurations = useSelector((state) => state.configurations.configurations);
  const bookings = useSelector((state) => state.bookings.bookings);
  // Paginate the filtered categories
  const paginatedBookings = bookings && bookings.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );


  //deleting the booking

  const deleteBooking = async (bookingId) => {
    if (window.confirm('Are you sure you want to delete?')) {

      try {
        const response = await fetch(`${apiUrl}/api/agencies/bookings/delete`, {
          method: "DELETE",
          headers: {
            'Authorization': `Bearer ${agency.token}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ bookingId })
        })

        const json = await response.json()
        if (response.ok) {
          toast.success(json.message)
          getBookings()

        }
        if (!response.ok) {
          toast.error(json.message)

        }
      } catch (error) {
        toast.error(error.message)

      }
    }
  }


  
  //deleting the booking

  const approveBooking = async (bookingId) => {
    if (window.confirm('Are you sure you want to update the Booking status?')) {

      try {
        const response = await fetch(`${apiUrl}/api/agencies/bookings/approve`, {
          method: "PUT",
          headers: {
            'Authorization': `Bearer ${agency.token}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ bookingId })
        })

        const json = await response.json()
        if (response.ok) {
          toast.success(json.message)
          getBookings()

        }
        if (!response.ok) {
          toast.error(json.message)

        }
      } catch (error) {
        toast.error(error.message)

      }
    }
  }

  const VoucherPrint = (booking,gender) => {
    if (!booking) {
      toast.error('Missing required booking details');
      return;
    }


  // Create a hidden iframe
  const iframe = document.createElement('iframe');
  iframe.style.position = 'absolute';
  iframe.style.width = '0';
  iframe.style.height = '0';
  iframe.style.border = '0';

  document.body.appendChild(iframe);
document.title=`${booking.members[0].name}'s Voucher`

    // Wait for external stylesheets to load before writing the content
    const printContentString = `
    <!DOCTYPE html>
      <html>
        <head>
          <!-- Bootstrap CSS -->
          <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC" crossorigin="anonymous">
          
          <!-- Font Awesome CSS -->
             <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.7.2/css/all.min.css" integrity="sha512-Evv84Mr4kqVGRNSgIGL/F/aIDqQb7xQ2vcrdIwxfjThSH8CSR7PBEakCr51Ck+w+/U6swU2Im1vVX0SVk9ABhg==" crossorigin="anonymous" referrerpolicy="no-referrer" />
          <!-- Google Material Icons -->
          <link rel="stylesheet" href="https://fonts.googleapis.com/icon?family=Material+Icons|Material+Icons+Outlined">
       <link rel="stylesheet" href="https://fonts.googleapis.com/icon?family=Material+Icons|Material+Icons+Outlined">
          <link href="https://fonts.googleapis.com/css2?family=Noto+Nastaliq+Urdu&display=swap" rel="stylesheet">
          <title>${booking.members[0].name} Booking Voucher</title>
         <style>
          @import url('https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=Noto+Nastaliq+Urdu:wght@400..700&display=swap');

            @page {
            size: A4;
            margin: 0.2cm;
          }

          body {
            margin: 0;
            font-family: Arial, sans-serif;
          }
            .header-container span {
              color: #6D76A1;
              font-size: 10px;
              font-weight: 500;
              text-transform:capitalize;
            }
            .header-container strong {
              color: #000;
              font-size: 11px;
              font-weight: 500;
              text-transform:capitalize;
            }
            .header-container h4 {
              color: ${(vouchercolors&&vouchercolors.header_color)?vouchercolors.header_color:"#0C0B0B"};
              text-align: center;
              font-size: 16px;
              font-weight: 600;
              padding:0px
            }
            .header-container small {
              color: #6D76A1;
              text-align: center;
              font-size: 12px;
              font-weight: 500;
              margin:0px;
              padding:0px;
              display:block;
            }

             .header-container .shirka_logo{
             height:40px;
             width:40px;
             }

            .header-container .shirka_logo img{
             height:100%;
             width:100%;
             border-radius:10px;
             object-fit: cover;
             }

            .info_row {
              border-radius: 10px;
             
            }
            .info_row h6 {
             color: ${(vouchercolors&&vouchercolors.header_color)?vouchercolors.header_color:"#0C0B0B"};
              font-size: 14px;
              font-weight: 600;
            }
            .header-logo {
              width: 55px;
              height:55px;
              border-radius:10px;
              object-fit: cover;
            }
           
             
           .table-wrapper {
                border-radius: 5px;
                overflow: hidden;
              }
                .table .thead1{
             background: ${(vouchercolors&&vouchercolors.table_bg_color)?vouchercolors.table_bg_color:"#CF9137"};
              
              border:1px solid ${(vouchercolors&&vouchercolors.table_bg_color)?vouchercolors.table_bg_color:"#CF9137"};
                }
                .table .thead2{
             background: ${(vouchercolors&&vouchercolors.thead_bg_color)?vouchercolors.thead_bg_color:"#FED9A4"};
             
                border:1px solid ${(vouchercolors&&vouchercolors.thead_bg_color)?vouchercolors.thead_bg_color:"#FED9A4"};
                }
            .table th {
             color: black;
           
              font-size: 9px;
              font-weight: 600;
              text-transform:capitalize;
              padding:1.5px;
              border:0px;
            }
              .table tbody{
              border:0.6px solid ${(vouchercolors&&vouchercolors.thead_bg_color)?vouchercolors.thead_bg_color:"#FED9A4"};

              }
              .table tbody tr{
              border:0.6px solid ${(vouchercolors&&vouchercolors.thead_bg_color)?vouchercolors.thead_bg_color:"#FED9A4"};
              }
            .table td {
              color: #0C0B0B;
              font-size: 8px;
              font-weight: 500;
              text-transform:capitalize;
              padding:1.4px;
              border:0px;
            }

            table, tr, td {
              page-break-inside: avoid; /* Prevent splitting tables */
            }
            .instruction, .contact {
              page-break-inside: avoid; /* Prevent breaking within these sections */
            }
              .instruction p, .contact {
                page-break-inside: auto; /* Allow breaking if content is too large */
              }

             .instruction .header {
              color: ${(vouchercolors&&vouchercolors.header_color)?vouchercolors.header_color:"#CF9137"};
             
              font-size: 13px;
              font-weight: 600;
            }
               .instruction .inner{
               border-radius:4px;
               height:auto;
               }
            
            // .instruction .urdu_paragraph *{
            //   font-size: 8px !important;
            //   line-height: 2.3 !important;
            //   margin: 0;
            //   padding: 0;
            // }
            .ql-align-left {
                text-align: left !important;
                direction: ltr;
              }

              .ql-align-center {
                text-align: center !important;
                direction: ltr;
              }

              .ql-align-right {
                text-align: right !important;
                direction: rtl;
              }
             .urdu_font{
            font-family: "Noto Nastaliq Urdu", serif;
            }
            
            .instruction hr{
            height:1px;
            color: #E4E4E4;
            }

            .contact {
                align-self: flex-start;
              }

            .contact .inner{  
               border-radius:4px;
              
               }
            .contact .header{
              color: ${(vouchercolors&&vouchercolors.header_color)?vouchercolors.header_color:"#CF9137"};
              font-size: 13px;
              font-weight: 600;
            }
            .contact strong{
           color: #454545;
            font-size: 10px;
            font-weight: 500;
            text-transform:capitalize;
              }

            .contact p{
            color: #454545;
            font-size: 10px;
            font-weight: 400;
              }
            .contact hr{
            height:1px;
            color: #E4E4E4;
            }

            .fixed-footer {
                position: fixed;
                bottom: 0;
                left: 0;
                width: 100%;
                z-index: 10;
                box-shadow: 0 -1px 5px rgba(0, 0, 0, 0.1);
                background:black;
                border-radius:4px;
              }
              .fixed-footer i{
              color:#CF9137;
              font-size:18px;
              margin:0px 3px 0px 3px;
              }
             
               .fixed-footer .left span{
              color:#CF9137;
              font-size:16px;
              font-weight:500;
              }
              .fixed-footer .middle img{
              height:40px;
              width:40px;
              }
              .fixed-footer .right span{
              color:#CF9137;
              font-size:12px;

              }
          </style>
        </head>
        <body>
          <div class="container-fluid mb-1 bg-white">
            <div class="row align-items-center mb-0 header-container p-0">
              <div class="col-3 text-start pt-0 mt-0">
                <div class="border py-2 px-3 rounded mt-0">
                  <div class='d-flex justify-content-between'>
                    <span class=" text-start">Voucher number</span>
                    <strong class="text-end">${booking.voucher_number||''}</strong>
                  </div>
                  <div class='d-flex justify-content-between'>
                    <span class="text-start">Created date</span>
                    <strong class="text-end">${new Date(booking.createdAt).toLocaleDateString()}</strong>
                  </div>
                </div>
              </div>
              <div class="col-6 text-center pt-0">
                <img src="${profile&&profile.logo_on_voucher?profile.profile_pic:profile.agencyLogo}" alt="Agency Logo" class="header-logo mb-2">
                <h4>${profile?.name?.length>30?`${profile?.name?.slice(0,30)}...`:profile?.name}</h4>
                <small class="text-muted pb-0">${profile&&profile.address_on_print? (profile?.address?.length>30?`${profile?.address?.slice(0,30)}...`:profile?.address):profile?.agencyAddress?.length>30?`${profile?.agencyAddress?.slice(0,30)}...`:profile?.agencyAddress}</small>
                <small class="text-muted py-0">${profile?.phone?.length>25?`${profile?.phone?.slice(0,25)}...`:profile?.phone}</small>
              </div>
              <div class="col-3 text-start border py-2 px-3 rounded mt-0">
               <div class='d-flex justify-content-between'>
               <div>
                <span class="text-muted">Shirka</span><br />
                <strong>${booking?.shirka?.length>13?`${booking?.shirka?.slice(0,13)}...`:booking?.shirka}</strong>
               </div>
               
               <div>
               <div class='shirka_logo my-auto'>
               ${booking.shirka_logo
                ? `<img src="${booking.shirka_logo}" alt="" class="header-logo my-auto">`
                : ""
              }              
               </div>
               </div>

               </div>
              </div>
            </div>
  
            <div class="row info_row pt-1 pb-2 px-3">
              <div class='col-12 py-0 my-1'>
              
              <div class=" table-wrapper table-responsive py-0 my-0">
                <table class="table py-0 my-0">
                 <thead class='thead1'>
                    <tr>
                      <th class="ps-2 ms-2"><strong>General Information About Service</strong></th>
                       <th colspan='5'></th>
                      
                    </tr>
                  </thead>
                  <thead class='thead2'>
                    <tr>
                      <th class="text-center">Adult</th>
                      <th class="text-center">Children</th>
                      <th class="text-center">Infants</th>
                      <th class="text-center">Departure Date</th>
                      <th class="text-center">Arrival Date</th>
                      <th class="text-center">Nights</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class='text-center'>${booking.adults||0}</td>
                      <td class="text-center">${booking.children||0}</td>
                      <td class="text-center">${booking.infants||0}</td>
                        <td class="text-center">${booking.departure_flight.departure_flight_date}</td>
                        
                        <td class="text-center">${booking.arrival_flight.arrival_flight_date}</td>
                     
                      <td class=' text-center'>${booking.duration||"Nill"}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              </div>
  
              <div class='col-12 py-0 my-1'>
             
              <div class="table-wrapper table-responsive py-0 my-0">
                <table class="table py-0 my-0">
                      <thead class='thead1'>
                    <tr>
                      <th class="ps-2 ms-2"><strong>Departure Flight</strong></th>
                       <th colspan='6'></th>
                      
                    </tr>
                  </thead>
                  <thead class='thead2'>
                    <tr>
                      <th class="text-center">Airport</th>
                      <th class="text-center">Flight No</th>
                      <th class="text-center">Flight Class</th>
                      <th class="text-center">Dep Date</th>
                      <th class="text-center">Dep Time</th>
                      <th class="text-center">Arrival Date</th>
                      <th class="text-center">Arrival Time</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class='text-center'>${booking.departure_flight.departure_location ||'Nill'}</td>
                      <td class="text-center">${booking.departure_flight.departure_flight_number||"Nill"}</td>
                      <td class="text-center">${booking.departure_flight.departure_flight_class||"Nill"}</td>
                      <td class="text-center">${booking.departure_flight.departure_flight_date}</td>
                     
                      <td class="text-center">${booking.departure_flight.departure_time||"Nill"}</td>
                       <td class="text-center">${booking.departure_flight.departure_to_flight_date}</td>
                     
                      <td class='text-center'>${booking.departure_flight.departure_to_time||"Nill"}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              </div>
             
  
              <div class='col-12 py-0 my-1'>
            
              <div class="table-wrapper table-responsive py-0 my-0">
                <table class="table py-0 my-0">
                
                      <thead class='thead1'>
                    <tr>
                      <th class="ps-2 ms-2"><strong>Return Flight</strong></th>
                       <th colspan='6'></th>
                      
                    </tr>
                  </thead>
                  <thead class='thead2'>
                    <tr>
                      <th class="text-center">Airport</th>
                      <th class="text-center">Flight No</th>
                      <th class="text-center">Flight Class</th>
                      <th class="text-center">Dep Date</th>
                      <th class="text-center">Dep Time</th>
                      <th class="text-center">Arrival Date</th>
                      <th class="text-center">Arrival Time</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class=' text-center'>${booking.arrival_flight.arrival_location||"Nill"}</td>
                      <td class="text-center">${booking.arrival_flight.arrival_flight_number||"Nill"}</td>
                      <td class="text-center">${booking.arrival_flight.arrival_flight_class||"Nill"}</td>

                      <td class="text-center">${booking.arrival_flight.arrival_flight_date}</td>
                     
                      <td class="text-center">${booking.arrival_flight.arrival_time}</td>

                       <td class="text-center">${booking.arrival_flight.take_off_flight_date}</td>

                     
                      <td class='text-center'>${booking.arrival_flight.take_off_time||"Nill"}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              </div>
            
              
              <div class='col-12 py-0 my-1'>
               ${booking.isHotel ? `
              
              <div class="table-wrapper table-responsive py-0 my-0">
                <table class="table py-0 my-0">
                 <thead class='thead1'>
                    <tr>
                      <th class="ps-2 ms-2"><strong>Accommodation Detail</strong></th>
                       <th colspan='5'></th>
                      
                    </tr>
                  </thead>
                  <thead class='thead2'>
                    <tr>
                      <th class="text-center">City</th>
                      <th class="text-center">Hotel</th>
                      <th class="text-center">Check in</th>
                      <th class="text-center">Check out</th>
                      <th class="text-center">Room type</th>
                      <th class="text-center">Nights</th>
                    </tr>
                  </thead>
                  <tbody>
                    ${booking.accomodation_details.map(accom => `
                      <tr class='py-0 my-0'>
                        <td class='text-center'>${accom.hotel_city||"Nill"}</td>
                        <td class="text-center">${accom.hotel_name||"Nill"}</td>

                         <td class="text-center">${accom.check_in_date}</td>
                        <td class="text-center">${accom.check_out_date}</td>
                      
                       
                        <td class="text-center">${booking.room_type||"Nill"}</td>
                        <td class='text-center'>${accom.hotel_duration||"Nill"}</td>
                      </tr>`).join('')}
                  </tbody>
                </table>
              </div>` : ''}
              </div>
  
             

              <div class='col-12 py-0 my-1''>
              
               <h6 class="mb-1">Transportation Details</h6>
              <div class="table-wrapper table-responsive py-0 my-0">
                <table class="table py-0 my-0">
                 <thead class='thead1'>
                    <tr>
                      <th class="ps-2 ms-2"><strong>Transportation Details</strong></th>
                       <th colspan='2'></th>
                      
                    </tr>
                  </thead>
                  <thead class='thead2'>
                    <tr>
                      <th class='text-center'>Trasnport</th>
                      <th class='text-center'>Trasnport Services For</th>
                      <th class='text-center'>Ziyarat</th>
                      
                    </tr>
                  </thead>
                  <tbody >
                    <tr>
                      <td class='text-center'>${booking.transport_details||"Nill"}</td>
                      <td class='text-center'>${booking.transport_services_for||"Nill"}</td>
                      <td class='text-center'>${booking.ziyarat||"Nill"}</td>
                     
                    </tr>
                  </tbody>
                </table>
              </div>
              </div>

  
              <div class='col-12 py-0 my-0''>
              
              <div class="table-wrapper table-responsive py-0 my-0">
                <table class="table py-0 my-0">
                 <thead class='thead1'>
                    <tr>
                      <th class="ps-2 ms-2"><strong>Mutamer's (Pilgrims) Details</strong></th>
                       <th colspan='7'></th>
                      
                    </tr>
                  </thead>
                  <thead class='thead2' >
                    <tr>
                      <th class="text-center">Pilgrim name</th>
                      <th class="text-center">Passport No</th>
                      <th class="text-center">DOB</th>
                      <th class="text-center">Age Group</th>
                      <th class="text-center">Visa no</th>
                      <th class="text-center">Issue date</th>
                      <th class="text-center">Group code</th>
                      <th class="text-center">Mofa Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    ${booking.members.filter(member=>(gender?member.gender.toLowerCase()===gender.toLowerCase():member.gender)).map(member => `
                      <tr>
                        <td class=' text-center'>${member.name}</td>
                        <td class="text-center">${member.ppNo}</td>

                        <td class="text-center">${member.dob}</td>
                        <td class="text-center">${member.age_group}</td>
                        <td class="text-center">${member.visa_number}</td>

                        <td class="text-center">${member.visa_issue_date}</td>
                      
                        <td class="text-center">${booking.group_code}</td>

                         <td class="text-center">${member.mofa_date}</td>
                      </tr>`).join('')}
                  </tbody>
                </table>
              </div>
              </div>
              
            <div class='col-9 mt-1 py-0 instruction ${(instructions&&(instructions.content?.trim()!==''&&instructions.content?.trim()!=='<p><br></p>')&&instructions.isUrdu)?'order-2 text-end ':'order-1 text-start '}'>
            <div class='px-2 border inner pt-2 pb-3 '> 
            <h6 class="header ${(instructions&&(instructions.content?.trim()!==''&&instructions.content?.trim()!=='<p><br></p>')&&instructions.isUrdu)?'text-end urdu_font mb-3':'text-start english_font mb-2'}">${(instructions&&(instructions.content?.trim()!==''&&instructions.content?.trim()!=='<p><br></p>')&&instructions.isUrdu)?'اہم ہدایات':'Instructions'}</h6>
            ${(!instructions || !instructions.content?.trim() || instructions.content.trim() === '<p><br></p>') 
                ? `<p class=' paragraph'>During Hajj or Umrah, pilgrims should first ensure they are in a state of Ihram, which involves wearing specific garments and making the intention to perform the pilgrimage. Upon arrival in Makkah, the first step is to perform Tawaf, circling the Kaaba seven times in a counterclockwise direction. After Tawaf, pilgrims should perform Sa'i, walking seven times between the hills of Safa and Marwah. It's important to stay hydrated and maintain a respectful demeanor throughout the journey. Finally, remember to engage in prayers and reflection, making the most of this spiritual experience.</p>` 
                : ""}
                ${(instructions&&instructions.content?.trim()!==''&&instructions.content.trim() !== '<p><br></p>'&&!instructions.isUrdu)? `<p class='paragraph'>${instructions?.content}</p>` 
                  : ""}
                  <div class='urdu_paragraph'>
                   ${(instructions&&instructions.content?.trim()!==''&&instructions.content.trim() !== '<p><br></p>'&&instructions.isUrdu)? `<h5 class=''>${instructions?.content}</h5>` 
                  : ""}
                  </div>
               
            
          
            </div>
            
             </div>

           <div class='col-3 mt-1 py-0 contact ${(instructions&&(instructions.content?.trim()!==''&&instructions.content?.trim()!=='<p><br></p>')&&instructions.isUrdu)?'order-1 text-end':'order-2 text-start'}'>
           <div class='p-2 border inner'> 
            <h6 class="header ${(instructions&&(instructions.content?.trim()!==''&&instructions.content?.trim()!=='<p><br></p>')&&instructions.isUrdu)?'text-end urdu_font mb-3':'text-start mb-2'}">${(instructions&&(instructions.content?.trim()!==''&&instructions.content?.trim()!=='<p><br></p>')&&instructions.isUrdu)?'رابطہ کی تفصیلات':'Contact'}</h6>
          
            ${profile.focal_persons.map(person =>
                  ` 
              <div class='d-flex justify-content-between'>
                <strong>${person.city} / ${person.name}</strong>
                <p>${person.phone}</p>
              </div>
              `).join('')}
           </div>
           
          </div>


          
            </div>

           <div class="fixed-footer px-2 py-1 text-center">
          <div class='d-flex justify-content-between my-auto'>
          <div class="left my-auto">
          <i class="fa-brands fa-linkedin"></i>
          <i class="fa-brands fa-square-facebook"></i>
          <i class="fa-brands fa-instagram"></i>
          <i class="fa-brands fa-square-x-twitter"></i>
          <i class="fa-brands fa-tiktok"></i>
          <i class="fa-brands fa-youtube"></i>
          <i class="fa-brands fa-pinterest"></i>
          <i class="fa-brands fa-quora"></i>
          <span class='ms-1'>@Gohijaz</span>
          </div>
          <div class="middle my-auto">
          <img src=${logo} alt=''/>
          </div>
          <div class="right my-auto">
          <i class="fa-brands fa-edge"></i> <span> www.gohijaz.com</span>
          <i class="fa-solid fa-phone"></i> <span> +92 000 000 0000</span>
          
          </div>
          </div>
        </div>
            
          </div>
        </body>
      </html>
    `;
    iframe.contentWindow.document.open();
    iframe.contentWindow.document.write(printContentString);
    iframe.contentWindow.document.close();
  

    setTimeout(() => {
      iframe.contentWindow.print();
      document.body.removeChild(iframe); 
document.title=`Booking Vouchers`
    }, 500);

  }
  
  const collapsed = useSelector((state) => state.collapsed.collapsed);
  return (
    <div className={`${collapsed ? "collapsed mt-5 " : "main mt-5"}`}>
      <div className="container-fluid bg-none my-0 mt-4">
        {!newBooking &&
          <div className="row px-2 mt-5 pt-4">
            <div className="col-md-12 data_table p-2 pb-3">
              <div className="d-flex justify-content-between searchbar pb-2 pt-2 px-md-3 my-auto">
                <div className="d-flex left my-auto mb-2 mb-md-0 ps-3 ps-md-0">
                  <h6>Bookings</h6>
                </div>
                <div className="d-flex right my-auto">
                  {/* <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-6 search_icon_svg">
                <path strokeLinecap="round" strokeLinejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
              </svg>
              <input type="text"  value={search} onChange={handleSearchChange} placeholder='Seacrh..' /> */}
                  <button className='add_btn btn ms-1' onClick={() => setNewBooking(true)}>New Booking</button>
                </div>
              </div>
              <TableContainer>
                <Table sx={{ minWidth: 650 }} stickyHeader aria-label="simple table" className='text-center'>
                  <TableHead >
                    <TableRow >
                      <TableCell className='th text-center' >SN</TableCell>
                      <TableCell className='th text-center' >Voucher #</TableCell>

                      <TableCell className='th text-center'>Members</TableCell>
                      <TableCell className='th text-center'>Agency</TableCell>
                      <TableCell className='th text-center'>Package Name</TableCell>
                      <TableCell className='th text-center'>Package Price</TableCell>
                      <TableCell className='th text-center'>Duration</TableCell>
                      <TableCell className='th text-center'>Date (from/to)</TableCell>
                      <TableCell className='th text-center'>Travel Plan</TableCell>
                      <TableCell className='th text-center'>Voucher</TableCell>
                      <TableCell className='th text-center'>Approval</TableCell>
                      <TableCell className='th text-center'>Action</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {paginatedBookings && paginatedBookings.length > 0 ? paginatedBookings
                      .map((data, index) => (
                        <>
                          <TableRow className='table_row'>
                            <TableCell className='text-center td'>{index + 1}</TableCell>
                            <TableCell className='text-center td'>{data?.voucher_number||''}</TableCell>
                            <TableCell className='text-center td'>{data.members.length}</TableCell>
                            <TableCell className='text-center td'>{data.agencyName}</TableCell>
                            <TableCell className='text-center td'>{data.packageName}</TableCell>
                            <TableCell className='text-center td'>{data.totalPrice.toLocaleString()}</TableCell>
                            <TableCell className='text-center td'>{data.duration} days</TableCell>
                            <TableCell className='text-center td'>{data.departure_flight.departure_flight_date} to {data.arrival_flight.arrival_flight_date}</TableCell>
                            <TableCell className='text-center td'>{data.package_header?.includes('umrah') ? "Umrah" : "Hajj"}</TableCell>
                            <TableCell className='text-center td'>
                              {(data.package_header?.includes('umrah')&&data.isApproved)&&
                              <div className="dropdown">
                              <button type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                              <svg width="29" height="28" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M24.7847 14.5873C24.7847 14.5873 24.7874 14.0396 24.7874 13.4202C24.7874 8.1939 24.7874 5.58073 23.1643 3.95711C21.5412 2.3335 18.9288 2.3335 13.7041 2.3335C8.47934 2.3335 5.86698 2.3335 4.24386 3.95711C2.62074 5.58073 2.62074 8.1939 2.62074 13.4202C2.62074 18.6466 2.62074 21.2598 4.24386 22.8834C5.6049 24.2448 7.66153 24.4647 11.3707 24.5002" stroke="#6D76A1" stroke-width="1.5" stroke-linecap="round" />
                                    <path d="M2.62074 8.16699H24.7874" stroke="#6D76A1" stroke-width="1.5" stroke-linejoin="round" />
                                    <path d="M7.28741 18.6667H8.45408M11.9541 14H17.7874M7.28741 14H8.45408" stroke="#6D76A1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M20.1207 21.5835H20.1312" stroke="#6D76A1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M25.6881 21.0262C25.8654 21.2749 25.9541 21.3993 25.9541 21.5833C25.9541 21.7674 25.8654 21.8917 25.6881 22.1404C24.8912 23.2578 22.8561 25.6667 20.1207 25.6667C17.3854 25.6667 15.3503 23.2578 14.5534 22.1404C14.3761 21.8917 14.2874 21.7674 14.2874 21.5833C14.2874 21.3993 14.3761 21.2749 14.5534 21.0262C15.3503 19.9088 17.3854 17.5 20.1207 17.5C22.8561 17.5 24.8912 19.9088 25.6881 21.0262Z" stroke="#6D76A1" stroke-width="1.5" />
                                  </svg>
                              </button>
                              <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                <li><Link className="dropdown-item" onClick={() => VoucherPrint(data,'')}>Combine Voucher</Link></li>
                                <li><Link className="dropdown-item" onClick={() => VoucherPrint(data,'male')}>Males  Voucher</Link></li>
                                <li><Link className="dropdown-item" onClick={() => VoucherPrint(data,'female')}>Females Voucher </Link></li>
                              </ul>
                            </div>
                              }
                            
                              

                            </TableCell>
                            <TableCell className='text-center td'>{data.isApproved?"Approved":"Pending"}</TableCell>

                            <TableCell className='td text-center'>
                              <div className="btn-group" role="group" aria-label="Basic example">
                              {profile&&profile?.role?.toLowerCase().includes('agency') &&
                                <button onClick={() => handleEditBooking(data)}>
                                <svg viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M10.0403 1.85156H8.35113C4.12815 1.85156 2.43896 3.54075 2.43896 7.76373V12.8313C2.43896 17.0543 4.12815 18.7435 8.35113 18.7435H13.4187C17.6417 18.7435 19.3309 17.0543 19.3309 12.8313V11.1421" stroke="#08A5DC" stroke-width="1.52027" stroke-linecap="round" stroke-linejoin="round" />
                                  <path d="M14.2974 2.71332L7.642 9.36873C7.38862 9.62211 7.13524 10.1204 7.08457 10.4836L6.72139 13.0258C6.58626 13.9464 7.2366 14.5883 8.1572 14.4616L10.6994 14.0985C11.0542 14.0478 11.5525 13.7944 11.8143 13.541L18.4697 6.88562C19.6184 5.73697 20.1589 4.40251 18.4697 2.71332C16.7805 1.02413 15.4461 1.56467 14.2974 2.71332Z" stroke="#08A5DC" stroke-width="1.52027" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                  <path d="M13.3428 3.66797C13.9087 5.68655 15.488 7.26594 17.5151 7.84027" stroke="#08A5DC" stroke-width="1.52027" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                              </button>
                                }
                                {(profile&&profile?.can_edit_voucher &&profile.role?.toLowerCase().includes('party') &&!data.isApproved) &&
                                <button onClick={() => handleEditBooking(data)}>
                                <svg viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M10.0403 1.85156H8.35113C4.12815 1.85156 2.43896 3.54075 2.43896 7.76373V12.8313C2.43896 17.0543 4.12815 18.7435 8.35113 18.7435H13.4187C17.6417 18.7435 19.3309 17.0543 19.3309 12.8313V11.1421" stroke="#08A5DC" stroke-width="1.52027" stroke-linecap="round" stroke-linejoin="round" />
                                  <path d="M14.2974 2.71332L7.642 9.36873C7.38862 9.62211 7.13524 10.1204 7.08457 10.4836L6.72139 13.0258C6.58626 13.9464 7.2366 14.5883 8.1572 14.4616L10.6994 14.0985C11.0542 14.0478 11.5525 13.7944 11.8143 13.541L18.4697 6.88562C19.6184 5.73697 20.1589 4.40251 18.4697 2.71332C16.7805 1.02413 15.4461 1.56467 14.2974 2.71332Z" stroke="#08A5DC" stroke-width="1.52027" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                  <path d="M13.3428 3.66797C13.9087 5.68655 15.488 7.26594 17.5151 7.84027" stroke="#08A5DC" stroke-width="1.52027" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                              </button>
                                }
                                
                                <button onClick={() => deleteBooking(data._id)}>
                                  <svg viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M16.6523 4.80811L16.1289 13.2752C15.9952 15.4386 15.9283 16.5202 15.3861 17.2979C15.118 17.6823 14.7728 18.0068 14.3725 18.2507C13.5629 18.7439 12.4792 18.7439 10.3117 18.7439C8.14144 18.7439 7.05629 18.7439 6.24611 18.2498C5.84556 18.0055 5.50029 17.6804 5.23229 17.2953C4.69022 16.5164 4.62483 15.4332 4.49405 13.2668L3.9834 4.80811" stroke="#FF5858" stroke-width="1.52027" stroke-linecap="round" />
                                    <path d="M2.71631 4.80764H17.919M13.7431 4.80764L13.1665 3.61822C12.7835 2.82813 12.592 2.43308 12.2617 2.1867C12.1884 2.13205 12.1108 2.08344 12.0297 2.04134C11.6639 1.85156 11.2249 1.85156 10.3468 1.85156C9.44674 1.85156 8.9967 1.85156 8.62482 2.0493C8.54241 2.09312 8.46376 2.1437 8.3897 2.20052C8.05553 2.45688 7.86887 2.86639 7.49554 3.6854L6.98398 4.80764" stroke="#FF5858" stroke-width="1.52027" stroke-linecap="round" />
                                    <path d="M8.20605 14.0981L8.20605 9.03058" stroke="#FF5858" stroke-width="1.52027" stroke-linecap="round" />
                                    <path d="M12.4292 14.0983L12.4292 9.03076" stroke="#FF5858" stroke-width="1.52027" stroke-linecap="round" />
                                  </svg>
                                </button>

                                {(profile&&profile?.role?.toLowerCase().includes('agency') &&data.partyId) &&
                                <button onClick={() => approveBooking(data._id)}>
                                  {!data.isApproved ?
                                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"className="size-6 text-success">
                                  <path fill-rule="evenodd" d="M19.916 4.626a.75.75 0 0 1 .208 1.04l-9 13.5a.75.75 0 0 1-1.154.114l-6-6a.75.75 0 0 1 1.06-1.06l5.353 5.353 8.493-12.74a.75.75 0 0 1 1.04-.207Z" clip-rule="evenodd" />
                                </svg>
                                  :

                                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="size-6 text-danger">
                                  <path fill-rule="evenodd" d="M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" />
                                </svg>
                                  }
                                
                              </button>
                                }
                              </div>
                            </TableCell>
                          </TableRow>
                          <hr />
                        </>
                      )) :
                      <TableRow className='table_row' sx={{ marginBottom: 2 }}>
                        <TableCell colSpan={6} className='text-center td'></TableCell>
                        <TableCell className='text-center td'>No result</TableCell>
                        <TableCell colSpan={5} className='text-center td'></TableCell>
                      </TableRow>

                    }
                  </TableBody>
                </Table>

              </TableContainer>
              {/* Pagination */}
              <div className="d-flex justify-content-end mt-3">
                <Pagination
                  count={Math.ceil(bookings.length / rowsPerPage)}
                  page={page}
                  onChange={handlePageChange}
                  className="custom-pagination"

                />
              </div>
            </div>
          </div>
        }


        {/* New Booking */}
        {newBooking &&
          <div className="row px-2 mt-5 pt-4">
            <div className="col-md-12 data_table p-2 pt-1 pb-3 my-auto new_package">
              <div className="card p-4 border-0">
                <div className="row">
                  <div className="d-flex justify-content-between px-1 info_header">
                    <div className="left">
                      <h4 className="mb-3">Booking Details</h4>
                    </div>
                  </div>
                  <hr />
                </div>

                <div className="row my-3">
                  <h5 className="mb-2">Group Information</h5>
                  <div className="col-md-3 px-1 my-2">
                    <label htmlFor="" className='required'>
                      Select Package
                    </label>
                    <select name="" id="" value={packageId} onChange={(e) => { setpackageId(e.target.value); setroom_type(''); settotalPrice(0) }} required>
                      <option value="">Select</option>
                      {packages && packages.filter(d => d.package_header === package_type && d.isActive && !d.isPending).map((data, index) => (
                        <option value={data._id} key={index}>{data.package_title}, Available Slots {data.total_slots - data.sold}</option>
                      ))}
                    </select>
                  </div>

                  {(package_type === 'umrah package' && packageId && packages.find(p => p._id === packageId)?.isHotel) &&
                    <div className="col-md-3 px-1 my-2">
                      <label htmlFor="" className='required'>
                        Room Type
                      </label>
                      <select
                        id="hajjDuration"
                        value={room_type}
                        onChange={(e) => setroom_type(e.target.value)}
                        required
                      >
                        <option value="">Select</option>
                        {packages?.find((pkg) => pkg._id === packageId)?.pricing.map((data, index) => (
                          <option value={data.room_type} key={index}>
                            {data.room_type} (Adult: {data.first_price.price?.toLocaleString()}, Child:{data.second_price.price}, Infant: {data.third_price.price}) {data.first_price.currency}
                          </option>
                        ))}
                      </select>
                    </div>
                  }

{package_type === 'hajj package' &&
                    <>
                      <div className="col-md-3 px-1 my-2">
                        <label htmlFor="hajjDuration" className='required'>
                          Hajj Duration
                        </label>
                        <select
                          id="hajjDuration"
                          value={room_type}
                          onChange={(e) => { setroom_type(e.target.value); settotalPrice(0) }}
                          required
                        >
                          <option value="">Select Duration</option>
                          {packages?.find((pkg) => pkg._id === packageId)?.pricing.map((data, index) => (
                            <option value={data.room_type} key={index}>
                              {data.room_type}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="col-md-3 px-1 my-2">
                        <label htmlFor="selectAmount" className='required'>
                          Select Amount
                        </label>
                        <select
                          id="selectAmount"
                          value={totalPrice}
                          onChange={(e) => settotalPrice(e.target.value)}
                          required
                        >
                          <option value="">Select Amount</option>
                          {packages && packages
                            ?.find((pkg) => pkg._id === packageId)
                            ?.pricing.filter((d) => d.room_type?.toLowerCase() === room_type?.toLowerCase()) // Filter to match selected room type
                            .map((data, index) => (
                              <>
                                <option value={data.first_price.price} key={index}>
                                  Shared Room {data.first_price.price.toLocaleString()}
                                </option>
                                <option value={data.second_price.price} key={index}>
                                  Three Beds {data.second_price.price.toLocaleString()}
                                </option>
                                <option value={data.third_price.price} key={index}>
                                  Double Bed {data.third_price.price.toLocaleString()}
                                </option>
                              </>
                            ))}
                        </select>
                      </div>
                    </>

                  }

{package_type === 'umrah package' &&
                    <div className="col-md-3 px-1 my-2">
                      <label className="required">Transport Shirka</label>
                      <select name="" id="" value={shirkaId} onChange={(e) => {setshirkaId(e.target.value); }} >
                        <option value="">Select</option>
                        {configurations && configurations.filter(c => c.type.trim().toLowerCase().includes('shirka')).map((data, index) => (
                          <option value={data._id}>{data.title}</option>
                        ))}
                      </select>
                    </div>
                  }

                  <div className="col-md-3 px-1 my-2">
                    <label >Group Code</label>
                    <input
                      type="text"
                      value={group_code}
                      onChange={(e) => setgroup_code(e.target.value)}
                      placeholder="Group code"
                      

                    />
                  </div>

                  <div className="col-md-3 px-1 my-2">
                    <label htmlFor="totalMembers" className=''>No of People</label>
                    <input
                      type="number"
                      id="totalMembers"
                      value={totalMembers}

                      disabled
                      placeholder="Members here"
                      required
                      min="1"

                    />
                  </div>
                  <div className="col-md-3 px-1 my-2">
                    <label htmlFor="adults" className=''>Adults </label>
                    <input
                      type="number"
                      id="adults"
                      disabled
                      value={adults}
                      onChange={handleAdultsChange}
                      placeholder="Enter here"
                      required
                      min="0"
                    />
                  </div>
                  <div className="col-md-3 px-1 my-2">
                    <label htmlFor="children">Children</label>
                    <input
                      type="number"
                      id="children"
                      disabled
                      value={children}
                      onChange={handleChildrenChange}
                      placeholder="Enter here"
                      required
                      min="0"
                    />
                  </div>
                  <div className="col-md-3 px-1 my-2">
                    <label htmlFor="infants">Infants</label>
                    <input
                      type="number"
                      id="infants"
                      disabled
                      value={infants}
                      onChange={handleInfantsChange}
                      placeholder="Enter here"
                      required
                      min="0"
                    />
                  </div>
                  <div className="col-md-8 px-1 my-2">
                    <label htmlFor="infants">Remarks</label>
                    <textarea

                      value={remarks}
                      onChange={(e) => setremarks(e.target.value)}
                      placeholder="Add Remarks"

                    />
                  </div>
                </div>

                <div className="row mt-2 members">
                  <div className="text-end mb-2">
                    <button className='add_member_btn' onClick={addNewMember}>+ Add Member</button>
                  </div>
                  
                  {totalMembers > 0 && members.map((member, index) => (
                    <div className="col-md-12 my-1 d-flex justify-content-between py-3 rounded member" key={index}>
                      <div className="left d-flex">
                        <h5 className='my-auto'>{index === 0 ? "Group Leader" : "Member"}  {index === 0 ? "" : index + 1}</h5>
                        <p className='my-auto ms-1'>({member.name}, {member.age_group})</p>
                        {(member.name && member.age_group && member.dob && member.ppNo && member.age_group && member.gender && member.mofa_date) ? <i className="fa-solid fa-check ok_member ms-2"></i> : <i className="fa-solid fa-xmark not_ok_member ms-2"></i>}
                      </div>
                      <div className="right">
                        <button className='my-auto mx-2' onClick={() => handleAddDetails(index)}>+ Details</button>
                        {members.length>1 &&
                        <button className='my-auto mx-2 delete_btn' onClick={() => deleteMember(index)}>Remove</button>
                        }
                      </div>
                    </div>
                  ))}
                </div>
                <hr />

                <div className="d-flex justify-content-between mt-4 px-3">
                  <button className="px-3 py-2 back_btn me-2" onClick={() => { resetForm() }} disabled={loading1}>
                    Cancel
                  </button>
                  <button
                    className="px-3 py-2 save_btn"
                    onClick={() => {
                      editedBookingId ? updateBooking() : addNewBooking();
                    }}
                    disabled={loading1}
                  >
                    {loading1 ? "Saving" : "Submit"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        }

      </div>
      <Dialog className='p-0'
        open={openNew}
        keepMounted
        aria-describedby="alert-dialog-slide-description"
        style={{ zIndex: 1000 }}
        PaperProps={{
          style: {
            overflow: "visible", 
          },
        }}
        
      >
        <div className="container-fluid">
          <div className="row ">
            <div className="col-md-12 px-0 m-0">

              <div className="card add_new_modal px-2">
                <div className="card-header bg-white ">
                  Select booking type
                </div>
                <div className="card-body pt-0">
                  <div className="row  py-2">
                    <div className="col-md-12 mt-2 mb-3 px-5 justify-content-between d-flex">
                      <div className="left ">
                        <div className="content px-2 py-3 text-center" style={package_type === 'hajj package' ? { border: '1px solid var(--primary)' } : {}} onClick={() => setpackage_type('hajj package')}>
                          <div className="image p-1">
                            <img src={hajj_package} alt="" />
                          </div>
                          <button onClick={() => setpackage_type('hajj package')} className="radio_btn btn mt-2" style={package_type === 'hajj package' ? { background: 'var(--primary)', color: 'white', border: '1px solid var(--primary)' } : {}}>
                            <Radio
                              size="small"
                              checked={package_type === 'hajj package'}
                              name="radio-buttons"
                              className="me-auto"
                              style={{
                                padding: "3px",
                                color: package_type === 'hajj package' ? "white" : "#667085", // Fill radio color when active
                              }}
                              inputProps={{ 'aria-label': ' Hajj Package' }}
                            />
                            Hajj Booking
                          </button>
                        </div>
                      </div>
                      <div className="right">
                        <div className="content px-2 py-3 text-center" style={package_type === 'umrah package' ? { border: '1px solid var(--primary)' } : {}} onClick={() => setpackage_type('umrah package')}>
                          <div className="image p-1">
                            <img src={umrah_package} alt="" />
                          </div>
                          <button onClick={() => setpackage_type('umrah package')} className="radio_btn btn mt-2" style={package_type === 'umrah package' ? { background: 'var(--primary)', color: 'white', border: '1px solid var(--primary)' } : {}}>
                            <Radio
                              size="small"
                              checked={package_type === 'umrah package'}
                              name="radio-buttons"
                              className="me-auto"
                              style={{
                                padding: "3px",
                                color: package_type === 'umrah package' ? "white" : "#667085", // Fill radio color when active
                              }}
                              inputProps={{ 'aria-label': ' umrah package' }}
                            />
                            Umrah Booking
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex justify-content-between mt-1 pb-0">
                      <button className="btn cancel_btn mx-2  py-2" type='button' onClick={() => handleCloseNew()} disabled={loading1}>Cancel</button>
                      <button className="btn save_btn mx-2 " onClick={() => { setNewBooking(true); setOpenNew(false) }}>Next</button>
                    </div>

                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </Dialog>



      {/* Adding member details */}


      {/* Dialog for Adding/Editing Member Details */}
      <Dialog
        className="p-0"
        open={isDialogOpen}
        maxWidth='lg'
        keepMounted
        aria-describedby="alert-dialog-slide-description"
      >
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12 px-0 m-0 new_package">
              <div className="card add_new_modal px-2">
                <div className="card-header bg-white">Add Details</div>
                <div className="card-body pt-0">
                  <div className="row py-2">
                    <div className="col-md-3 px-1 my-2">
                      <label className='required'>Full Name</label>
                      <input
                        type="text"
                        // placeholder='Full name'
                        value={editedMember?.name || ""}
                        onChange={(e) =>
                          handleFieldChange("name", e.target.value)
                        }
                        required
                      />
                    </div>
                    <div className="col-md-3 mt-2 px-1 my-2">
                      <label className='required'>DOB</label>
                      <DatePicker  className='input' value={editedMember?.dob ? dayjs(editedMember.dob, ["YYYY-MM-DD", "DD-MM-YYYY", "YYYY-DD-MM"]) : null}  placeholder={editedMember?.dob||"Date Of Birth"} disabledDate={(current) =>current && current.isAfter(dayjs(new Date().toISOString().split("T")[0], 'YYYY-MM-DD'))} onChange={(date, dateString) => handleFieldChange("dob",dateString)} format="DD/MM/YYYY" getPopupContainer={(trigger) => trigger.closest(".MuiDialog-root")}/>
                        
                      {/* <input
                        type="text"
                        max={new Date().toISOString().split("T")[0]}
                      
                        onFocus={(e) => (e.target.type = "date")}
                        onBlur={(e) => {
                          if (!e.target.value) e.target.type = "text";
                        }}
                        value={editedMember?.dob || ""}
                        onChange={(e) => handleFieldChange("dob", e.target.value)}
                        required
                      /> */}
                    </div>

                    <div className="col-md-3 px-1 my-2">
                      <label className='required'>Age Group</label>

                      <select name="" id="" value={editedMember?.age_group || ""}
                        required
                        disabled 
                        >
                        <option value="">Select</option>
                        <option value="Adult">Adult</option>
                        <option value="Child">Child</option>
                        <option value="Infant">Infant</option>

                      </select>
                    </div>
                    <div className="col-md-3 px-1 my-2">
                      <label className='required'>Gender</label>
                      <select name="" id="" value={editedMember?.gender || ""}
                        required
                        onChange={(e) =>
                          handleFieldChange("gender", e.target.value)
                        }>
                        <option value="">Select</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>

                      </select>

                    </div>
                    <div className="col-md-3 px-1 my-2">
                      <label className='required'>Passport Number</label>
                      <input
                        type="text"
                        //  placeholder='Passport number'
                        value={editedMember?.ppNo || ""}
                        onChange={(e) =>
                          handleFieldChange("ppNo", e.target.value)
                        }
                        required
                      />
                    </div>

                    <div className="col-md-3 px-1 my-2">
                      <label className=''>Passport Expiry Date</label>
                      <DatePicker  className='input' value={editedMember?.pp_expiry_date ? dayjs(editedMember.dob, ["YYYY-MM-DD", "DD-MM-YYYY", "YYYY-DD-MM"]) : null} placeholder={editedMember?.pp_expiry_date||"Passport Expiry Date"} disabledDate={(current) =>current && current.isBefore(dayjs(new Date().toISOString().split("T")[0], 'YYYY-MM-DD'))} onChange={(date, dateString) => handleFieldChange("pp_expiry_date",dateString)} format="DD/MM/YYYY" getPopupContainer={(trigger) => trigger.closest(".MuiDialog-root")}/>

                      {/* <input
                        type="text"
                        min={new Date().toISOString().split("T")[0]}
                       
                        onFocus={(e) => (e.target.type = "date")}
                        onBlur={(e) => {
                          if (!e.target.value) e.target.type = "text";
                        }}
                        value={editedMember?.pp_expiry_date || ""}
                        onChange={(e) =>
                          handleFieldChange("pp_expiry_date", e.target.value)
                        }

                      /> */}
                    </div>

                    <div className="col-md-3 px-1 my-2">
                      <label>Visa Number</label>
                      <input
                        type="text"

                        // placeholder='Visa number'
                        value={editedMember?.visa_number || ""}
                        onChange={(e) =>
                          handleFieldChange("visa_number", e.target.value)
                        }
                      />
                    </div>
                    <div className="col-md-3 px-1 my-2">
                      <label>Visa Issue Date</label>
                      <DatePicker  className='input' disabledDate={(current) =>current && current.isAfter(dayjs(new Date().toISOString().split("T")[0], 'YYYY-MM-DD'))} value={editedMember?.visa_issue_date ? dayjs(editedMember.visa_issue_date, ["YYYY-MM-DD", "DD-MM-YYYY", "YYYY-DD-MM"]) : null} placeholder={editedMember?.visa_issue_date||"Visa Issue Date"} onChange={(date, dateString) => handleFieldChange("visa_issue_date",dateString)} format="DD/MM/YYYY" getPopupContainer={(trigger) => trigger.closest(".MuiDialog-root")}/>

                      {/* <input
                        type="text"
                        max={new Date().toISOString().split("T")[0]}
                       
                        onFocus={(e) => (e.target.type = "date")}
                        onBlur={(e) => {
                          if (!e.target.value) e.target.type = "text";
                        }}
                        value={editedMember?.visa_issue_date || ""}
                        onChange={(e) =>
                          handleFieldChange("visa_issue_date", e.target.value)
                        }
                      /> */}

                    </div>

                    <div className="col-md-3 px-1 my-2">
                      <label className=''>Phone</label>
                      <input
                        type="text"
                        // placeholder='Phone number'
                        value={editedMember?.phone || ""}
                        onChange={(e) =>
                          handleFieldChange("phone", e.target.value)
                        }
                      
                      />

                    </div>

                    <div className="col-md-3 px-1 my-2">
                      <label className='required'>Mofa Date</label>
                      <DatePicker  className='input' value={editedMember?.mofa_date ? dayjs(editedMember.mofa_date, ["YYYY-MM-DD", "DD-MM-YYYY", "YYYY-DD-MM"]) : null} disabledDate={(current) =>current && current.isAfter(dayjs(new Date().toISOString().split("T")[0], 'YYYY-MM-DD'))} placeholder={editedMember?.mofa_date||"Mofa Date"} onChange={(date, dateString) => handleFieldChange("mofa_date",dateString)} format="DD/MM/YYYY" getPopupContainer={(trigger) => trigger.closest(".MuiDialog-root")}/>

                      {/* <input
                        type="text"
                        max={new Date().toISOString().split("T")[0]}
                        
                        onFocus={(e) => (e.target.type = "date")}
                        onBlur={(e) => {
                          if (!e.target.value) e.target.type = "text";
                        }}
                        value={editedMember?.mofa_date || ""}
                        onChange={(e) =>
                          handleFieldChange("mofa_date", e.target.value)
                        }
                        required
                      /> */}

                    </div>
                    <div className="col-md-3 px-1 my-2">
                      <label className=''>PNR Number</label>
                      <input
                        type="text"
                        placeholder='PNR number'
                        value={editedMember?.pnr_number || ""}
                        onChange={(e) =>
                          handleFieldChange("pnr_number", e.target.value)
                        }

                      />

                    </div>


                    <div className="col-md-3 px-1 my-2">
                      <label>Address</label>

                      <input
                        type="text"
                        // placeholder='Address here'
                        value={editedMember?.address || ""}
                        onChange={(e) =>
                          handleFieldChange("address", e.target.value)
                        }
                      />

                    </div>

                    <div className="col-md-3 px-1 my-2">
                      {/* <label htmlFor="file-upload">Add Cover Image</label> */}
                      {!editedMember?.pp_image ? (
                        <label htmlFor="file-upload" className="custom-file-upload d-flex flex-column align-items-center">
                          <svg width="37" height="37" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg">

                          </svg>
                          <h6 className="mt-1">
                            Upload File Here (Passport)
                            <p className="text-muted">or drag and drop PNG, JPG (max. 5MBs)</p>
                          </h6>
                          <input
                            id="file-upload"
                            type="file"
                            accept="image/*"
                            style={{ display: 'none' }}
                            onChange={(e) => handlePPImage(e, memberIndex)}

                          />
                        </label>
                      ) : (
                        <div className="selected-image">
                          <label htmlFor="selected-file-upload">
                            <img
                              src={editedMember?.pp_image}
                              alt="Cover"
                              style={{ cursor: 'pointer' }}
                            />
                          </label>
                          <input
                            id="selected-file-upload"
                            type="file"
                            accept="image/*"
                            style={{ display: 'none' }}
                            onChange={(e) => handlePPImage(e, memberIndex)}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="card-footer d-flex justify-content-between bg-white my-2">
                  <button
                    className="px-3 py-2 back_btn me-2"
                    onClick={() => {
                      setIsDialogOpen(false);


                    }}
                  >
                    Cancel
                  </button>
                  <button
                    className="px-3 py-2 save_btn"
                    onClick={handleSaveChanges}

                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  )
}
